var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthArb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3676 26C20.5473 26 26.3676 20.1797 26.3676 13C26.3676 5.8203 20.5473 0 13.3676 0C6.18785 0 0.367554 5.8203 0.367554 13C0.367554 20.1797 6.18785 26 13.3676 26Z",
    fill: "#EDEFF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6439 3.53577L13.5108 3.97446V16.7033L13.6439 16.8322L19.7314 13.3396L13.6439 3.53577Z",
    fill: "#343434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6439 3.53577L7.55621 13.3396L13.6439 16.8322V10.6539V3.53577Z",
    fill: "#8C8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6438 17.9508L13.5688 18.0396V22.5738L13.6438 22.7863L19.7351 14.4601L13.6438 17.9508Z",
    fill: "#3C3C3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6438 22.7863V17.9508L7.55615 14.4601L13.6438 22.7863Z",
    fill: "#8C8C8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6439 16.8322L19.7314 13.3396L13.6439 10.6539V16.8322Z",
    fill: "#141414"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55615 13.3396L13.6438 16.8322V10.6539L7.55615 13.3396Z",
    fill: "#393939"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6049_33678)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.4875,
    y: 6,
    width: 14.88,
    height: 14.88,
    rx: 7.44,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5206 10.8528V16.0274C19.5206 16.36 19.6948 16.661 19.9852 16.83L24.4681 19.4173C24.7533 19.581 25.107 19.581 25.3922 19.4173L29.8751 16.83C30.1602 16.6663 30.3398 16.36 30.3398 16.0274V10.8528C30.3398 10.5201 30.1655 10.2191 29.8751 10.0502L25.3922 7.46285C25.107 7.29917 24.7533 7.29917 24.4681 7.46285L19.9852 10.0502C19.7001 10.2139 19.5258 10.5201 19.5258 10.8528H19.5206Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9043 14.4432L25.2654 16.1963C25.2496 16.2438 25.2496 16.2966 25.2654 16.3494L26.3637 19.3644L27.6362 18.6305L26.1103 14.4432C26.0733 14.3482 25.9413 14.3482 25.9043 14.4432Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 11.4968C27.1505 11.4018 27.0185 11.4018 26.9815 11.4968L26.3426 13.2499C26.3268 13.2974 26.3268 13.3502 26.3426 13.403L28.1432 18.34L29.4157 17.606L27.1875 11.5021V11.4968Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9275 7.65816C24.9592 7.65816 24.9909 7.66872 25.0173 7.68456L29.8645 10.4831C29.9226 10.5148 29.9543 10.5781 29.9543 10.6415V16.2385C29.9543 16.3019 29.9173 16.3653 29.8645 16.3969L25.0173 19.1955C24.9909 19.2113 24.9592 19.2219 24.9275 19.2219C24.8958 19.2219 24.8642 19.2113 24.8378 19.1955L19.9905 16.3969C19.9324 16.3653 19.9007 16.3019 19.9007 16.2385V10.6362C19.9007 10.5728 19.9377 10.5095 19.9905 10.4778L24.8378 7.67928C24.8642 7.66344 24.8958 7.65288 24.9275 7.65288V7.65816ZM24.9275 6.83972C24.7533 6.83972 24.5843 6.88196 24.4259 6.97173L19.5786 9.77025C19.2671 9.94977 19.077 10.2771 19.077 10.6362V16.2332C19.077 16.5923 19.2671 16.9197 19.5786 17.0992L24.4259 19.8977C24.579 19.9875 24.7533 20.0297 24.9275 20.0297C25.1018 20.0297 25.2707 19.9875 25.4291 19.8977L30.2764 17.0992C30.5879 16.9197 30.778 16.5923 30.778 16.2332V10.6362C30.778 10.2771 30.5879 9.94977 30.2764 9.77025L25.4239 6.97173C25.2707 6.88196 25.0965 6.83972 24.9222 6.83972H24.9275Z",
    fill: "#9DCCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7172 18.3454L22.166 17.1204L23.0636 17.8649L22.2241 18.6358L21.7172 18.3454Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5156 10.2401H23.2853C23.1956 10.2401 23.1111 10.2982 23.0794 10.3827L20.4446 17.6061L21.7171 18.34L24.6212 10.3827C24.6476 10.3088 24.5948 10.2349 24.5209 10.2349L24.5156 10.2401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6699 10.2401H25.4397C25.3499 10.2401 25.2654 10.2982 25.2337 10.3827L22.224 18.6304L23.4965 19.3644L26.7703 10.3827C26.7967 10.3088 26.7439 10.2349 26.6699 10.2349V10.2401Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6049_33678"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.4875,
    y: 6,
    width: 14.88,
    height: 14.88,
    rx: 7.44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthArb);
export default __webpack_public_path__ + "static/media/eth_arb.fe0fa6548ae296df5ee23e73c6d8d77b.svg";
export { ForwardRef as ReactComponent };